
export const retreatRouting = [
	{
    path: "/assetManage/retreat/list",
    name: "retreat-list",
    meta: { title: "领用&退库" },
    component: () =>
      import(/* webpackChunkName: "retreat-list" */ "@/views/asset-management/retreat/list/index.vue"),
  },
	{
    path: "/assetManage/retreat/receiving/create",
    name: "retreat-receiving-create",
    meta: { title: "新建资产领用" },
		hidden:true,
    component: () =>
      import(/* webpackChunkName: "retreat-receiving-create" */ "@/views/asset-management/retreat/receiving/form-create/index.vue"),
  },
	{
    path: "/assetManage/retreat/receiving/detail/:id",
    name: "retreat-receiving-detail",
    meta: { title: "资产领用详情" },
		hidden:true,
    component: () =>
      import(/* webpackChunkName: "retreat-receiving-detail" */ "@/views/asset-management/retreat/receiving/form-detail/index.vue"),
  },
	{
    path: "/assetManage/retreat/receiving/edit/:id",
    name: "retreat-receiving-edit",
    meta: { title: "编辑资产领用" },
		hidden:true,
    component: () =>
      import(/* webpackChunkName: "retreat-receiving-edit" */ "@/views/asset-management/retreat/receiving/form-create/index.vue"),
  },
	{
    path: "/assetManage/retreat/retire/create",
    name: "retreat-retire-create",
    meta: { title: "新建资产退库" },
		hidden:true,
    component: () =>
      import(/* webpackChunkName: "retreat-retire-create" */ "@/views/asset-management/retreat/retire/form-create/index.vue"),
  },
	{
    path: "/assetManage/retreat/retire/detail/:id",
    name: "retreat-retire-detail",
    meta: { title: "资产退库详情" },
		hidden:true,
    component: () =>
      import(/* webpackChunkName: "retreat-retire-detail" */ "@/views/asset-management/retreat/retire/form-detail/index.vue"),
  },
	{
    path: "/assetManage/retreat/retire/edit/:id",
    name: "retreat-retire-edit",
    meta: { title: "编辑资产退库" },
		hidden:true,
    component: () =>
      import(/* webpackChunkName: "retreat-retire-edit" */ "@/views/asset-management/retreat/retire/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/assetManage/retreat/receiving/flowPrint/:id",
    name: "retreat-receiving-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "retreat-receiving-flow-print" */ "@/views/asset-management/retreat/receiving/flow-print/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/assetManage/retreat/retire/flowPrint/:id",
    name: "retreat-retire-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "retreat-retire-flow-print" */ "@/views/asset-management/retreat/retire/flow-print/index.vue"
      ),
  },
]